import React, { useState } from 'react';

const FaqAccordionItem = ({
	question,
	id,
	answerList,
	videoUrl,
	type,
	position,
	status,
	category,
}) => {
	const [activeIndex, setActiveIndex] = useState(null);

	const toggleAccordion = (index) => {
		setActiveIndex(activeIndex === index ? null : index);
	};
	return (
		<>
			{/* Accordion Items */}
			<div id="accordionACCOUNT_RELATEDVZY" role="tablist">
				<h3
					className={`ui-accordion-header ${activeIndex === 0 ? "ui-state-active" : "ui-state-default"}`}
					role="tab"
					onClick={() => toggleAccordion(0)}
				>
					<span
						className={`ui-accordion-header-icon ui-icon ${activeIndex === 0 ? "ui-icon-triangle-1-s" : "ui-icon-triangle-1-e"}`}
					></span>
					<span>{question}</span>
				</h3>
				{activeIndex === 0 && (
					<div
						className="faq-p ui-accordion-content"
						role="tabpanel"
					>
						<div dangerouslySetInnerHTML={{ __html: answerList }} />
					</div>
				)}
			</div>
		</>
	);
}
export default FaqAccordionItem;
